import useFeatureFlags from 'hooks/useFeatureFlags'
import type { FC } from 'react'
import { useSelector } from 'react-redux'
import { isGroupUser } from 'utils'
import TeamList from './TeamList'
import TeamListGroups from './TeamListGroups'
import TeamListGroupsV2 from './TeamListGroupsV2'

export const TeamListGroupsRedirect: FC = () => {
  const flags = useFeatureFlags({
    flagNames: ['group_access_management', 'roles_permissions_v2']
  })?.data

  const user = useSelector(
    (state: { global: { user: any } }) => state.global.user
  )
  const isGroupRole = isGroupUser(user?.role)

  const groupAccessManagementEnabled = flags?.group_access_management?.enabled
  const rolesPermissionsV2Enabled = flags?.roles_permissions_v2?.enabled

  if (groupAccessManagementEnabled && isGroupRole) {
    // V2 group dashboard (CM-3388) is gated behind both the group flag and the
    // roles/permissions V2 flag; otherwise fall back to the legacy group list.
    if (rolesPermissionsV2Enabled) {
      return <TeamListGroupsV2 />
    }
    return <TeamListGroups />
  }

  return <TeamList />
}
